import { useAtom } from 'jotai';
import { makeStyles } from '@material-ui/styles';
import { Dropdown, Theme } from '@bizzabo/design-system';
import { useChatClient } from '@bizzabo/chat-core';
import TriggerActionsMenu from './TriggerActionsMenu';
import DeleteMessageAction from './DeleteMessageAction';
import { useMessageContext } from 'stream-chat-react';
import BanUserAction from './BanUserAction';
import PinMessageAction from './PinMessageAction';
import { isMessageReply, pinUnpinMessage } from '../Utils/MessageUtils';
import useTypeTracking from '../../../analytics';
import { messageIdToDeleteAtom, userIdToBanMessageAtom } from '../../../atoms/MessageActionsAtoms';

const MessageActions = () => {
    const classes = useStyles();

    const { message } = useMessageContext();
    const [, setMessageIdToDelete] = useAtom(messageIdToDeleteAtom);
    const [, setUserIdToBanMessage] = useAtom(userIdToBanMessageAtom);
    const { trackClickEvent } = useTypeTracking();
    const { client } = useChatClient();
    const isReplyMessage = isMessageReply(message);

    return (
        <Dropdown
            placement="left-start"
            button={({ isOpen }) => <TriggerActionsMenu isOpen={isOpen} />}
            onOpen={() => {
                trackClickEvent({
                    buttonType: 'MODERATOR_CLICK_MENU',
                    subCategory: 'OPEN_MENU',
                });
            }}
        >
            {(closeDropdown: () => void) => (
                <div className={classes.container}>
                    {!isReplyMessage && (
                        <PinMessageAction
                            isPinned={message.pinned}
                            onPinClicked={() => {
                                pinUnpinMessage(client, message);
                                trackClickEvent({
                                    buttonType: 'MODERATOR_CLICK_MENU',
                                    subCategory: message.pinned ? 'UNPIN_MESSAGE' : 'PIN_MESSAGE',
                                });
                                closeDropdown();
                            }}
                        />
                    )}
                    <DeleteMessageAction
                        onDeleteClicked={() => {
                            setMessageIdToDelete(message.id);
                            trackClickEvent({
                                buttonType: 'MODERATOR_CLICK_MENU',
                                subCategory: 'DELETE_MESSAGE',
                            });
                            closeDropdown();
                        }}
                    />
                    <BanUserAction
                        onBanClicked={() => {
                            setUserIdToBanMessage(message.id);
                            trackClickEvent({
                                buttonType: 'MODERATOR_CLICK_MENU',
                                subCategory: 'BLOCK_USER',
                            });
                            closeDropdown();
                        }}
                    />
                </div>
            )}
        </Dropdown>
    );
};

export default MessageActions;

const useStyles = makeStyles(
    (theme: Theme) => ({
        container: {
            display: 'flex',
            'flex-direction': 'column',
            'align-items': 'flex-start',
            padding: '16px 16px 16px 12px',
            'box-shadow': '0px 4px 14px rgba(0, 0, 0, 0.1)',
            'border-radius': 12,
            width: 160,
            background: theme.palette.greys['100'],
        },
    }),
    {
        classNamePrefix: MessageActions.name,
    }
);
